import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';

import { customTheme } from './theme';

export const StyleProvider: React.FC = ({ children }) => {
  return <ChakraProvider theme={customTheme}>{children}</ChakraProvider>;
};
